export enum PointerEvents {
  AUTO = 'auto',
  NONE = 'none',
  UNSET = 'unset',
}
